module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/02-443dab1d8092142826aa3f210ddb6dd9.jpg";